﻿import { IContact } from '../contact';
import { ICenter } from '../center';
import { IMicrositeRecipientCoachLogEntry, IMicrositeRecipientCommunication, IMicrositeRecipientImage, IMicrositeRecipientLog, IMicrositeRecipientRequest } from '.';

export interface IMicrositeRecipient extends IMicrositeRecipientRequest {
    shortCodeUses: number,
    coordinatorContact: IContact,
    secondaryCoordinatorContact: IContact,
    coachContact: IContact,
    hideFromCoach: boolean,
    currentStatusDescription: string,
    customSiteStatusId: number,
    customSiteStatusDescription: string,
    previousStatusId: number,
    previousStatusDescription: string,
    inviteSentDateTime: string,
    centerDecisionDateTime: string,
    nkrDecisionDateTime: string,
    submissionDateTime: string,
    submissionAttemptCount: number,
    submissionLastIssue: string,
    state: string,
    phonePrimary: string,
    primaryPhoneCanReceiveTexts: boolean,
    phoneSecondary: string,
    secondaryPhoneCanReceiveTexts: boolean,
    age: number,
    gender: string,
    languagePreference: string,
    isOnDeceasedWaitList: boolean,
    waitListStartDate: string,
    transplantUrgencyId: number,
    transplantUrgency: string,
    patientStory: string,
    patientStoryPending: string,
    patientWhy: string,
    patientWhyPending: string,
    imagesJson: string,
    imagesJsonPending: string,
    agreedToHipaa: boolean,
    layout: string,
    theme: string,
    carousel: string,
    micrositeType: string,
    aboType: string,
    initialVisitCount: number,
    learnMoreVisitCount: number,
    eligibleVisitCount: number,
    coachRequestedDateTime: string,
    coachAssignedDateTime: string,
    mostRecentCoachContactDateTime: string,
    nextFollowupDate: string,
    images: IMicrositeRecipientImage[],
    imagesPending: IMicrositeRecipientImage[],
    fullName: string,
    center: ICenter,
    comms: IMicrositeRecipientCommunication[],
    coachLogEntries: IMicrositeRecipientCoachLogEntry[],
    isCoachAllowedToEdit: boolean,
    cheekSwabConsentInitials: string,
    cheekSwabConsentDate: string,
    recipientId: number,
    donorOriginDescription: string,
    logs: IMicrositeRecipientLog[],
    isAlreadyDeactivated: boolean,
    canBeActiveOrCustom: boolean,
    campaignId: number,
    campaignName: string
}
